/** @format */

import { Form, FormikProvider } from "formik";
import { FormHelperText, Stack, TextField, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import WABAFormV2 from "../../components/WABAFormV2";
import { LoadingButton } from "@mui/lab";
import Iconify from "../../components/Iconify";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import swal from "../../reusables/CustomSwal";
// import Col from "react-bootstrap/cjs/Col";
import { components } from "react-select";
import { FaAngleDown } from "react-icons/fa";
import Waba from "../../dao/Waba";
import { useSelector } from "react-redux";

import ReactSelect from "react-select";

UserForm.propTypes = {
  formik: PropTypes.object,
  mode: PropTypes.string,
  wabas: PropTypes.array,
  setWabas: PropTypes.func,
};

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <FaAngleDown color={"grey"} />
      </components.DropdownIndicator>
    )
  );
};

export default function UserForm({ formik, mode, wabas, setWabas }) {
  let user = useSelector(({ auth }) => auth.auth);
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;
  const [selectedRole, setSelectedRole] = useState(getFieldProps("role").value);
  // console.log(selectedRole);

  const [wabaSelection, setWabaOptions] = useState([]);
  useEffect(() => {
    getWabas();
  }, []);

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log("MW", result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    if (mode === "edit") {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wabas]);

  const onChangeRole = async (event) => {
    if (wabas.length > 0) {
      let popupResult = await swal.fire({
        title: "Confirm",
        text: "Changing roles will reset assigned WABA IDs. Proceed?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
      });
      if (!popupResult.isConfirmed) return;
    }
    getFieldProps("role").onChange(event);
    setSelectedRole(event.target.value);
    setWabas([]);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3} sx={{ mb: 5 }}>
          <Typography variant="h6">User Info</Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
              fullWidth
              label="First Name*"
              {...getFieldProps("first_name")}
              error={Boolean(touched.first_name && errors.first_name)}
              helperText={touched.first_name && errors.first_name}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              fullWidth
              label="Last Name*"
              {...getFieldProps("last_name")}
              error={Boolean(touched.last_name && errors.last_name)}
              helperText={touched.last_name && errors.last_name}
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
          <TextField
            fullWidth
            label="Job Title*"
            {...getFieldProps("job_title")}
            error={Boolean(touched.job_title && errors.job_title)}
            helperText={touched.job_title && errors.job_title}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            disabled={mode === "edit" || mode === "profile"}
            label="Email*"
            autoComplete="email"
            {...getFieldProps("email")}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Tenant*"
            {...getFieldProps("tenant")}
            error={Boolean(touched.tenant && errors.tenant)}
            helperText={touched.tenant && errors.tenant}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Phone Broadcast*"
            autoComplete="tel"
            {...getFieldProps("phone_number")}
            error={Boolean(touched.phone_number && errors.phone_number)}
            helperText={touched.phone_number && errors.phone_number}
            InputLabelProps={{ shrink: true }}
          />
        </Stack>

        {mode !== "profile" && (
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Typography variant="h6">Role</Typography>
              <FormControl
                disabled={mode === "edit" || mode === "profile"}
                fullWidth
                error={Boolean(touched.role && errors.role)}
              >
                <Select
                  {...getFieldProps("role")}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedRole}
                  onChange={onChangeRole}
                >
                  <MenuItem value="none" selected disabled>
                    Please select a role.
                  </MenuItem>
                  {user.role === "SUPER_ADMIN" && (
                    <MenuItem value={"SUPER_ADMIN"}>Super Admin</MenuItem>
                  )}
                  <MenuItem value={"ADMIN"}>Admin (Ops)</MenuItem>
                  <MenuItem value={"MEMBER"}>Member (Client)</MenuItem>
                </Select>
                {Boolean(touched.role && errors.role) && (
                  <FormHelperText>{errors.role}</FormHelperText>
                )}
              </FormControl>
            </Stack>

            {mode !== "profile" &&
              (selectedRole === "MEMBER" ? (
                <ReactSelect
                  menuPortalTarget={document.body}
                  onChange={(option) => {
                    setWabas([{ waba_id: option.value, label: option.label }]);
                  }}
                  placeholder={"WABA ID"}
                  value={
                    wabas.length > 0
                      ? {
                          label: wabas[0].label,
                          value: wabas[0].waba_id,
                        }
                      : ""
                  }
                  options={wabaSelection}
                  styles={{
                    option: (provided, state) => ({
                      ...provided,
                      cursor: "pointer",
                    }),
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#e6e6e6",
                    }),
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: "9999 !important",
                    }),
                  }}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                />
              ) : (
                // <TextField
                //   fullWidth
                //   label="WABA ID"
                //   value={wabas.length > 0 ? wabas[0].waba_id : ''}
                //   onChange={(e) => {
                //     setWabas([{waba_id: e.target.value}])
                //   }}
                //   InputLabelProps={{shrink: true}}
                // />
                selectedRole === "ADMIN" && (
                  <WABAFormV2
                    assignedWaba={wabas}
                    wabas={wabas}
                    setWabas={setWabas}
                  />
                )
              ))}
          </Stack>
        )}

        <Stack xs={12} direction="row" justifyContent="flex-end">
          <LoadingButton
            size="large"
            type="submit"
            style={{
              marginTop: 30,
            }}
            variant="contained"
            loading={isSubmitting}
          >
            <Iconify
              icon="eva:save-outline"
              width={22}
              height={22}
              sx={{ marginRight: 1 }}
            />
            Save
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
